<template>
  <div hidden>
    <input
      v-for="funder in funders"
      :key="funder.id"
      :name="name"
      :value="funder.id"
      type="hidden"
    />
  </div>
</template>

<script>
export default {
  props: {
    funders: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
